module.exports = {"name":"inviteToCard","audiences":["allMembers"],"autoTrack":true,"experimentAllocation":1,"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/inviteToCard.json
// module id = +VGC
// module chunks = 2